import "core-js/modules/es.error.cause.js";
import { __decorate } from "tslib";
import { Component, Watch, PropSync, Prop, InjectReactive } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import commonMixins from "@mixins/commonNewMixins";
import questionnaireEditorCore from "./questionnaireEditorCore.vue";
import questionnaireEditorActions from "./questionnaireEditorActions.vue";
let addSurveyForActivityDialog = class addSurveyForActivityDialog extends mixins(commonMixins) {
  constructor() {
    super(...arguments);
    this.editorState = {
      activeIndex: 1,
      isAnswerMode: false,
      isViewMode: false,
      submitLoading: false
    };
    this.resolve = null;
    this.reject = null;
  }
  get hasEditSpecialMode() {
    return Boolean(this.editSpecialMode);
  }
  inputValChange(visible) {
    if (visible) {
      this.handleDialogOpen();
    } else {
      this.handleDialogClose();
    }
  }
  getEditorCore() {
    return this.$refs.editorCore;
  }
  // 弹窗层只处理显示生命周期，问卷初始化交给核心层
  handleDialogOpen() {
    this.$nextTick(() => {
      const editorCore = this.getEditorCore();
      editorCore && editorCore.initQuestionnaire();
    });
  }
  handleDialogClose() {
    const editorCore = this.getEditorCore();
    editorCore && editorCore.clearValidate();
    typeof this.reject === "function" && this.reject();
  }
  handleCancel() {
    this.visible = false;
    if (typeof this.reject === "function") {
      this.reject(new Error("用户取消"));
    }
    this.$emit("cancel");
  }
  handleClose() {
    if (typeof this.reject === "function") {
      this.reject(new Error("弹窗关闭"));
    }
    this.$emit("close");
  }
  handleStateChange(state) {
    this.editorState = state;
  }
  handleSuccess(result) {
    this.$emit("success", result);
    this.success && typeof this.success === "function" && this.success(result);
    typeof this.resolve === "function" && this.resolve();
  }
  handleTemplateSuccess(templateId) {
    this.$emit("templateSuccess", templateId);
    this.templateSuccess && typeof this.templateSuccess === "function" && this.templateSuccess(templateId);
  }
  handlePreview() {
    this.getEditorCore().saveTemp();
  }
  handlePrevious() {
    this.getEditorCore().preNextClick();
  }
  handleNext() {
    this.getEditorCore().nextStep();
  }
  handleSubmitTemplate() {
    this.getEditorCore().nextStepToTemple();
  }
  handleSubmit() {
    this.getEditorCore().nextStep();
  }
  // 保留原有命令式打开方式和 Promise 返回契约
  open() {
    if (this.visible) {
      this.handleDialogOpen();
    } else {
      this.visible = true;
    }
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
};
__decorate([PropSync("modalVisible", {
  type: Boolean
})], addSurveyForActivityDialog.prototype, "visible", void 0);
__decorate([InjectReactive()], addSurveyForActivityDialog.prototype, "surveyType", void 0);
__decorate([Prop({
  default: ""
})], addSurveyForActivityDialog.prototype, "questionnaireId", void 0);
__decorate([Prop({
  default: ""
})], addSurveyForActivityDialog.prototype, "templateId", void 0);
__decorate([Prop({
  default: "ADD"
})], addSurveyForActivityDialog.prototype, "openMode", void 0);
__decorate([Prop({
  default: () => ({})
})], addSurveyForActivityDialog.prototype, "success", void 0);
__decorate([Prop({
  default: () => ({})
})], addSurveyForActivityDialog.prototype, "templateSuccess", void 0);
__decorate([Prop({
  default: ""
})], addSurveyForActivityDialog.prototype, "editSpecialMode", void 0);
__decorate([Prop({
  default: "QUESTIONNAIRE"
})], addSurveyForActivityDialog.prototype, "activityQuestionnaireType", void 0);
__decorate([Prop({
  default: "QUESTIONNAIRE"
})], addSurveyForActivityDialog.prototype, "activityQuestionnaireProperty", void 0);
__decorate([Prop({
  default: false
})], addSurveyForActivityDialog.prototype, "showVerificationConfig", void 0);
__decorate([Prop({
  default: () => {
    return {
      title: "自定义表单",
      label: "表单名称",
      type: "ACTIVITY"
    };
  }
})], addSurveyForActivityDialog.prototype, "surveyConfig", void 0);
__decorate([Watch("visible")], addSurveyForActivityDialog.prototype, "inputValChange", null);
addSurveyForActivityDialog = __decorate([Component({
  name: "addSurveyForActivityDialog",
  components: {
    questionnaireEditorCore,
    questionnaireEditorActions
  }
})], addSurveyForActivityDialog);
export default addSurveyForActivityDialog;